module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Believing Jesus: Are You Willing to Risk Everything?: A Journey Through the Book of Acts")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txc1",
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('i', [_vm._v("I’ve pitched my tent in the land of hope.")])]), _vm._v(" "), _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "sec-8"
    }
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CTS")]), _vm._v(" 2:26 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESSAGE ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1efcf474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter02.vue
// module id = 72
// module chunks = 0